// opervex-frontend/src/pages/System/User.js

import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Container, Row, Col, Form, InputGroup, Card, Button } from "react-bootstrap";
import { FaSearch, FaPlus, FaSave, FaPencilAlt } from "react-icons/fa";
import { MdOutlineCancel } from "react-icons/md";
import { TiKeyOutline } from "react-icons/ti";

import MaskedFormControl from "react-bootstrap-maskedinput";

import { useAuth } from "../../contexts/AuthContext";
import { SearchHelpModal } from "../../utils/SearchHelp";
import useOpervex from "../../hooks/useOpervex";
import ConfirmService from "../../components/ConfirmationModal/ConfirmService";

import ToastService from "../../services/ToastService";

const rolePageRequire = "USER_SYSTEM";

var dataDefault = {
  id: "",
  username: "",
  fullName: "",
  email: "",
  initialPassword: false,
  cpf: "",
  employee: null,
  administrator: false,
  disabled: false,
};

const actionsDefault = {
  create: true,
  change: true,
  delete: true,
  save: true,
  newPass: true,
};

const User = () => {
  const { roles, loadingGlobal } = useAuth();
  const [disabledField, setDisabledField] = useState(true);
  const [actions, setActions] = useState(actionsDefault);
  const [data, setData] = useState(dataDefault);
  const { id } = useParams();
  const OpervexAPI = useOpervex();

  useEffect(() => {
    const fetchData = async () => {
      commandAction({ ...actionsDefault, create: false });

      if (id) {
        await searchAPI(id);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  if (loadingGlobal) {
    return <div>Carregando...</div>;
  }

  const commandAction = (actions) => {
    const hasPermission = roles.find((role) => role.command === rolePageRequire);

    if (!hasPermission) {
      setActions(actionsDefault);
      return;
    }

    if (!actions.create) actions.create = !hasPermission.actions.some((action) => action.key === "Create");
    if (!actions.change) actions.change = !hasPermission.actions.some((action) => action.key === "Change");

    setActions({ ...actions });
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    let _value = value;

    if (name === "username") _value = _value.toUpperCase();

    var newData = { ...data, [name]: type === "checkbox" ? checked : _value };

    setData(newData);
  };

  // CRUD Handlers
  const handleButtonCreate = () => {
    setData({ ...dataDefault, initialPassword: true });
    commandAction({ ...actionsDefault, save: false });
    setDisabledField(false);
  };

  const handleButtonCancel = () => {
    if (data.id === "") {
      setData(dataDefault);
      setDisabledField(true);
      commandAction({ ...actionsDefault, create: false });
    } else {
      searchAPI(data.id);
    }
  };

  const handleButtonNewPassword = async () => {
    var body = { ...data };

    const result = await OpervexAPI.System.User.newPassword(body.username);

    if (result.errors) {
      await ConfirmService.show("Aviso", result.errors, true);
      return;
    }

    var message = "Nova senha solicitada com sucesso!";

    if (result.password) message += `</br></br>Nova Senha: <b>${result.password}</b>`;

    await ConfirmService.show("Aviso", message, true);

    await searchAPI(data.id);
  };

  const handleButtonSave = async () => {
    var body = { ...data };

    if (body.cpf) {
      body.cpf = body.cpf.replaceAll(".", "").replaceAll("-", "");
    }
    if (data.id) {
      const result = await OpervexAPI.System.User.update(body.id, body);

      if (result.errors) {
        await ConfirmService.show("Aviso", result.errors, true);
        return;
      }

      await searchAPI(data.id);

      ToastService.Success("Registro atualizado com sucesso!");
    } else {
      const result = await OpervexAPI.System.User.create(body);

      if (result.errors) {
        await ConfirmService.show("Aviso", result.errors, true);
        return;
      }

      await searchAPI(result.id);

      ToastService.Success("Registro criado com sucesso!" + result.password ? `</br>Senha</br><b>${result.password}</b>` : "");
    }
  };

  const handleButtonSearch = async () => {
    const item = await SearchHelpModal({
      urlData: "/System/Users/SearchHelp",
      schema: await OpervexAPI.System.User.schema(),
    });

    if (item && item.id) await searchAPI(item.id);
  };

  const handleButtonChange = async () => {
    setDisabledField(false);
    commandAction({ ...actionsDefault, save: false, newPass: false });
  };

  const searchAPI = async (id) => {
    setDisabledField(true);

    if (!id) return;

    var result = await OpervexAPI.System.User.findId(id);

    if (result && !result.error) {
      setData(result);
      commandAction({ ...actionsDefault, create: false, change: false });
    } else {
      setData(dataDefault);
      commandAction({ ...actionsDefault, create: false });
      alert(result.error);
    }
  };

  return (
    <>
      <Container className="mt-2">
        <Form>
          <Card className="mb-2">
            <Card.Header>
              <Row className="d-flex justify-content-between">
                <Col md={8}>
                  <h5>Cabeçalho</h5>
                </Col>
                <Col md={4} className="text-end">
                  <Button variant="success" size="sm" className="me-2" onClick={handleButtonCreate} hidden={actions.create}>
                    <FaPlus /> Novo
                  </Button>
                  <Button variant="primary" size="sm" className="me-2" onClick={handleButtonChange} hidden={actions.change}>
                    <FaPencilAlt /> Alterar
                  </Button>
                  <Button variant="danger" size="sm" className="me-2" onClick={handleButtonCancel} hidden={actions.save}>
                    <MdOutlineCancel /> Cancelar
                  </Button>
                  <Button variant="primary" size="sm" className="me-2" onClick={handleButtonSave} hidden={actions.save}>
                    <FaSave /> Salvar
                  </Button>
                </Col>
              </Row>
            </Card.Header>
            <Card.Body>
              <Row className="mb-2">
                <Col md={2}>
                  <Form.Group>
                    <Form.Label>Código</Form.Label>
                    <InputGroup>
                      <Form.Control type="text" size="sm" value={data.id} name="id" onChange={handleChange} disabled={true} />

                      <InputGroup.Text size="sm" type="button" onClick={handleButtonSearch}>
                        <FaSearch />
                      </InputGroup.Text>
                    </InputGroup>
                  </Form.Group>
                </Col>
                <Col md={8}>
                  <Form.Group>
                    <Form.Label>Nome Completo</Form.Label>
                    <Form.Control
                      type="text"
                      size="sm"
                      name="fullName"
                      maxLength={50}
                      value={data.fullName}
                      onChange={handleChange}
                      disabled={disabledField}
                    />
                  </Form.Group>
                </Col>

                <Col md={2} className="d-flex align-items-center">
                  <Form.Check
                    type="checkbox"
                    id="disabled"
                    checked={data.disabled}
                    name="disabled"
                    onChange={handleChange}
                    label="Inativo"
                    disabled={disabledField}
                  />
                </Col>
              </Row>
            </Card.Body>
          </Card>

          <Card className="mb-2">
            <Card.Header>
              <Row className="d-flex justify-content-between">
                <Col md={8}>
                  <h5>Dados de Login</h5>
                </Col>
                <Col md={4} className="text-end">
                  <Button variant="primary" size="sm" className="me-2" onClick={handleButtonNewPassword} hidden={actions.newPass}>
                    <TiKeyOutline /> Nova Senha
                  </Button>
                </Col>
              </Row>
            </Card.Header>
            <Card.Body>
              <Row className="mb-2">
                <Col md={2}>
                  <Form.Group>
                    <Form.Label>Usuário</Form.Label>
                    <Form.Control
                      type="text"
                      size="sm"
                      name="username"
                      maxLength={20}
                      value={data.username}
                      onChange={handleChange}
                      disabled={disabledField || data.id ? true : false}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>E-mail</Form.Label>
                    <Form.Control
                      type="text"
                      size="sm"
                      name="email"
                      maxLength={100}
                      value={data.email}
                      onChange={handleChange}
                      disabled={disabledField}
                    />
                  </Form.Group>
                </Col>
                <Col md={2}></Col>
                <Col md={2}>
                  <Form.Check // prettier-ignore
                    type="checkbox"
                    id="initialPassword"
                    checked={data.initialPassword}
                    name="initialPassword"
                    label="Senha Inicial"
                    disabled={true}
                  />
                  {<br />}
                  <Form.Check // prettier-ignore
                    type="checkbox"
                    id="administrator"
                    name="administrator"
                    checked={data.administrator}
                    label="Administrator"
                    disabled={true}
                  />
                </Col>
              </Row>
            </Card.Body>
          </Card>

          {/* ----- Additional -----*/}
          <Card className="mb-2">
            <Card.Header>
              <h5>Informações Adicionais</h5>
            </Card.Header>
            <Card.Body>
              <Row className="mb-2">
                <Col md={2}>
                  <Form.Group>
                    <Form.Label>CPF</Form.Label>
                    <MaskedFormControl
                      type="text"
                      size="sm"
                      mask="111.111.111-11"
                      name="cpf"
                      value={data.cpf}
                      onChange={handleChange}
                      disabled={disabledField}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Form>
      </Container>
    </>
  );
};

export default User;
